export default __webpack_public_path__ + "static/media/IO.24fe4b38.svg";